import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Inline, SocialIcon } from 'chaoskit/src/components';

const SocialGroup = props => {
  const { className, networks, wrap } = props;

  const classes = cx(className);
  const findNetwork = ({ service, url, title }) =>
    networks.find(network => network.service === service) && (
      <SocialIcon key={service} url={url} service={service} title={title} />
    );

  return (
    <Inline wrap={wrap} className={classes}>
      {networks.map(network => findNetwork(network))}
    </Inline>
  );
};

SocialGroup.propTypes = {
  className: PropTypes.string,
  networks: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.oneOf([
        'twitter',
        'facebook',
        'instagram',
        'youtube',
        'linkedin',
        'hacker-news',
        'rss',
      ]),
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
    })
  ).isRequired,
  wrap: PropTypes.bool,
};

export default SocialGroup;
